<div class="wrap">
    <div class="margin-large-bottom-res margin-large-top-res">
        <ul class="uk-flex-center" uk-tab>
            <li class="uk-active">
                <a>
                    Encaissement
                </a>
            </li>
            <li (click)="goToControl()" *ngIf="session.role.ability === 'super-admin'">
                <a href="/facturation/controle">
                    Controle
                </a>
            </li>
            <li (click)="goToGain()">
                <a href="/facturation/gain">
                    Auto Facturation
                </a>
            </li>
        </ul>
    </div>

    <div uk-grid class="uk-grid-small remove-grid-ml-pl">

        <div class="uk-width-1-2 uk-width-1-4@s uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block">
                <select class="uk-select" [(ngModel)]="month" (ngModelChange)="onMonthChange($event)">
                    <option value="0">Tous</option>
                    <option value="1">Janvier</option>
                    <option value="2">Février</option>
                    <option value="3">Mars</option>
                    <option value="4">Avril</option>
                    <option value="5">Mai</option>
                    <option value="6">Juin</option>
                    <option value="7">Juillet</option>
                    <option value="8">Août</option>
                    <option value="9">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                </select>
            </div>
            <div class="uk-form-controls uk-display-inline-block">
                <select class="uk-select" [(ngModel)]="selectYear" (ngModelChange)="onYearChange($event)">
                    <option *ngFor="let year of years; let i = index" value={{year}}>{{year}}</option>
                </select>
            </div>
        </div>

        <div class="uk-width-1-4@m uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <input class="search-bar" type="text" [(ngModel)]="search" placeholder="Rechercher"
                    (ngModelChange)="onSearchChange($event)" style="width: calc(100% - 20px);">
                <span class="uk-form-icon uk-form-icon-flip" style="right: 10px;">
                    <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                </span>
            </div>
        </div>

        <!-- <div class="uk-width-1-1 uk-margin-top">
            <button disabled class="button bold uk-display-inline-block uk-float-right" type="button">
                <span *ngIf="excelLoading === false">
                    <span class="vertical-align-middle" >Export</span>
                    <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user" class="uk-margin-left"/> 
                </span>
                <span *ngIf="excelLoading === true">
                    <div uk-spinner class="loading-small-button"></div>
                </span>
            </button>
        </div> -->
    </div>

    <div *ngIf="noResult === true && loadingStatus == false;" class="bold uk-margin-medium-top">
        Aucune donner n'est disponible pour le moment.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false">

        <div *ngIf="loadingStatus === false" class=" uk-margin-remove-top">

            <div *ngIf="virements.length == 0" class="bold uk-margin-medium-top">
                Il n'y a pas d'encaissement pour cette periode.
            </div>

            <div *ngFor="let virement of virements; let i = index"
                class="uk-border-rounded uk-width-1-1 vop-background-white uk-margin-medium-top uk-padding-small">

                <div uk-grid class="uk-width-1-1">
                    <div class="uk-width-1-2 item-column bold" style="font-size: 17px;">
                        <!-- {{ virement.gain }} -->
                        <div class="uk-display-block">
                            <span class="uk-text-small">Virement du <span class="uk-text-small"
                                    humanDateFormat="{{ virement.virementDate }}" noDay="true"
                                    shortened="true"></span></span>
                        </div>
                        <div class="uk-display-block">
                            <span class="uk-text-small uk-margin-small-left regular" style="margin: 0">Période du <span
                                    class="uk-text-small" humanDateFormat="{{ virement.dateDebut }}" noDay="true"
                                    shortened="true"></span> au <span class="uk-text-small"
                                    humanDateFormat="{{ virement.dateFin }}" noDay="true" shortened="true"></span>
                            </span>
                        </div>
                    </div>

                    <!-- <div class="uk-width-1-2 item-column bold uk-text-right" style="font-size: 17px;">
                        {{ virement.adherent }}
                    </div> -->

                    <a class="uk-width-1-2 uk-text-center"
                        href="/#/user/society/informations/{{ virement.adherentId }}">
                        <div class="uk-width-1-1 item-column bold uk-text-right uk-text-uppercase"
                            style=" font-size: 17px;">
                            {{ virement.adherent }}
                        </div>
                    </a>
                </div>


                <div class="uk-width-1-1 uk-margin-medium-top">
                    <div uk-grid *ngFor="let reservation of virement.courses; let i = index"
                        class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer"
                        [routerLink]="['/reservation/informations', reservation.Id]">
                        <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                            <div class="uk-display-block">
                                <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}"
                                    noDay="true" shortened="true"></span>
                                <span class="uk-text-small uk-margin-small-left regular"
                                    hours="{{ reservation.ISODateStart }}"></span>
                            </div>
                            <div class="uk-display-block">
                                <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true"
                                    shortened="true"></span>
                                <span class="uk-text-small uk-margin-small-left regular"
                                    hours="{{ reservation.ISODateEnd }}"></span>
                            </div>
                            <div class="separator"></div>
                        </div>
                        <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center"
                            style="font-size: 17px;">
                            {{ reservation.Vehicle }}
                        </div>
                        <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase"
                            style="font-size: 13px;">
                            {{ reservation.User }}
                        </div>
                        <!-- <div *ngIf="session.role.ability === 'super-admin'"
                            class="uk-visible@s uk-width-1-6 item-column light uk-text-uppercase"
                            style="font-size: 13px;">
                            {{ reservation.CodeSociety }}
                        </div> -->
                        <div class="uk-visible@s uk-width-expand item-column"></div>

                        <div class="uk-visible@s uk-width-1-12 item-column">
                            <span class="bold">{{ reservation.kilometre }} km</span>
                        </div>

                        <div class="uk-visible@s uk-width-1-12 item-column">
                            <span class="bold">{{ reservation.prix }} €</span>
                        </div>

                        <div class="uk-visible@m uk-width-1-12 item-column" style="font-size: 15px;">
                            #{{ reservation.Code }}
                        </div>
                    </div>
                </div>


                <div uk-grid class="uk-width-1-1 uk-margin-medium-top">
                    <div class="uk-width-4-5 item-column bold" style="font-size: 17px;">
                        <div class="uk-display-block">
                            <span class="uk-text-small">Somme encaissée par <span class="color-orange">VOP</span></span>
                        </div>
                        <div class="uk-display-block">
                            <span class="uk-text-small bold uk-margin-small-left regular"
                                style="margin: 0; font-size: 20px;">{{ virement.versee }} €</span>
                        </div>
                    </div>

                    <div class="uk-width-1-5">
                        <button disabled class="button bold uk-display-inline-block uk-float-right" type="button">
                            <span *ngIf="excelLoading === false">
                                <span class="vertical-align-middle uk-visible@s">FACTURE</span>
                                <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user"
                                    class="uk-margin-left@s" />
                            </span>
                            <span *ngIf="excelLoading === true">
                                <div uk-spinner class="loading-small-button"></div>
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

            <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin"
                *ngIf="maxPages > 0 && virements.length != 0">
                <div class=" uk-position-center">
                    <button [disabled]="currentPage === 1" class="uk-button button"
                        (click)="prevPage()">Précédent</button>
                    <div class="uk-display-inline-block" *ngFor="let item of [].constructor(maxPages); let i = index;">
                        <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}</div>
                        <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue"
                            (click)="goPage(i + 1)">
                            {{i + 1}}</div>
                    </div>
                    <button [disabled]="currentPage === maxPages" class="uk-button button uk-margin-left"
                        (click)="nextPage()">Suivant</button>
                </div>
            </div>

        </div>
    </div>